import https from '../../init/https';

//INFO-01 : Get routes to fetch the details of a trip/ayur pack/guid pack/camp for user based on
//the id of the package
export async function getDetailsFun(type, packId) {
    const result = await https.get(`info/pack-info/${type}/${packId}`);
    return result;
}

//INFO-02 : To get basic information of the organizer
export async function orgBasicFun(type, orgId) {
    const result = await https.get(`info/org/${type}/${orgId}`);
    return result;
}

//INFO-04 : To get basic information of the organizer
export async function orgPacksFun(type, orgId, limit, offset) {
    const result = await https.get(`info/pack/${type}/${orgId}?limit=${limit}&offset=${offset}`);
    return result;
}

//INFO-05 : To get trip Date details
export async function getDateDetailsFun(type, packId) {
    const result = await https.get(`info/date/${type}/${packId}`);
    return result;
}

//INFO-12 - Get reviews
export async function getReviewsData(type, packId, offset, limit) {
    const result = await https.get(`/info/reviews/org/${type}/${packId}?offset=${offset}&limit=${limit}`);
    return result;
}

//INFO-14 Trip details page related trips for particular organizer
export async function getInterestedTripsOrg(type, orgId) {
    const result = await https.get(`/info/org/realted/${type}/${orgId}`);
    return result;
}
